export const staffMembersSelector = state => state.whiteLabel.staff.get('list');
export const staffMembersLoadingSelector = state => state.whiteLabel.staff.get('isLoading');
